import { Button, Card, Container, Row } from "react-bootstrap";
import "./Portfolio.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

export default function Portfolio() {
  return (
    <div className="portfolio mt-5 mb-4" id="portfolio">
      <Container>
        <Row>
          <div className="col-md-12 col-12 col-sm-12 pt-4 mb-5  text-center heading">
            <h6>
              <span>PORTFOLIO</span>
            </h6>
          </div>
          <div className="col-md-12 col-12 col-sm-12">
            <Row className="align-items-center portfolioContainer justify-content-between">
              <Card data-aos="fade-up" className="mb-5 mt-5" style={{ width: "22rem", height: "28rem", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://i.ibb.co/RcG1jDP/Screenshot-2020-10-28-130845.png" />
                <Card.Body>
                  <Card.Title>Creative Agency</Card.Title>
                  <Card.Text>Creative Agency is a full-stack service selling web application.</Card.Text>
                  <Row className="px-3">
                    <a target="_blank" rel="noreferrer" className="mr-4" href="https://github.com/iamshakibb/creativeAgencyFrontend">
                      <FontAwesomeIcon icon={faGithub} />
                    </a>
                    <a target="_blank" rel="noreferrer" href="https://creative-agency-13260.web.app/">
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                  </Row>
                  <Row className="px-3 mt-2">
                    <span className="portfolioTag mr-3">React</span>
                    <span className="portfolioTag mr-3">Node</span>
                    <span className="portfolioTag mr-3">Mongo DB</span>
                    <span className="portfolioTag mr-3">Express</span>
                    <span className="portfolioTag mr-3">Firebase</span>
                  </Row>
                </Card.Body>
              </Card>
              <Card data-aos="fade-up" className="mb-5 mt-5" style={{ width: "22rem", height: "28rem", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://i.ibb.co/P1T1RRC/Screenshot-2020-10-28-142519.png" />
                <Card.Body>
                  <Card.Title>Travel Guru</Card.Title>
                  <Card.Text>This is a travel guiding web site. We suggest 3 destinations. Those are Sreemangal, Sajek, Cox's Bazar.</Card.Text>
                  <Row className="px-3">
                    <a target="_blank" rel="noreferrer" className="mr-4" href="https://github.com/iamshakibb/Travle_guru">
                      <FontAwesomeIcon icon={faGithub} />
                    </a>
                    <a target="_blank" rel="noreferrer" href="https://travle101.web.app/">
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                  </Row>
                  <Row className="px-3 mt-2">
                    <span className="portfolioTag mr-3">React</span>
                    <span className="portfolioTag mr-3">Material UI</span>
                    <span className="portfolioTag mr-3">Firebase</span>
                    <span className="portfolioTag mr-3">Slick Slider</span>
                  </Row>
                </Card.Body>
              </Card>
              <Card data-aos="fade-up" className="mb-5 mt-5" style={{ width: "22rem", height: "28rem", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://i.ibb.co/w02dhrX/Screenshot-2020-10-28-145902.png" />
                <Card.Body>
                  <Card.Title>Volunteer Network</Card.Title>
                  <Card.Text>Volunteer Network is a social volunteering events website. People can join any event they want.</Card.Text>
                  <Row className="px-3">
                    <a className="mr-4" target="_blank" rel="noreferrer" href="https://github.com/iamshakibb/volunteerNetworkfrontend">
                      <FontAwesomeIcon icon={faGithub} />
                    </a>
                    <a target="_blank" rel="noreferrer" href="https://volunteer-network-dd8d3.web.app/">
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                  </Row>
                  <Row className="px-3 mt-2">
                    <span className="portfolioTag mr-3">React</span>
                    <span className="portfolioTag mr-3">Node</span>
                    <span className="portfolioTag mr-3">Mongo DB</span>
                    <span className="portfolioTag mr-3">Express</span>
                    <span className="portfolioTag mr-3">Firebase</span>
                  </Row>
                </Card.Body>
              </Card>
            </Row>
          </div>

          <div className="col-md-12 col-12 col-sm-12 text-center">
            <a href="https://github.com/iamshakibb/" target="_blank" rel="noreferrer">
              <Button className="px-5 py-2 seeMoreBtn">SEE MORE</Button>
            </a>
          </div>
        </Row>
      </Container>
    </div>
  );
}
